import React from 'react';
import PropTypes from 'prop-types';
import MessageHandler from 'message-handler';
import { Form, Input, Rules } from 'Validation';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  loadPreviousStaticBuilderSection,
  loadStaticBuilderSection,
} from 'StaticBuilder/StaticBuilderActions';

const SaveActionsEnum = {
  SAVE_AND_CONTINUE: 1,
  SAVE_AND_SHARE: 2,
  SAVE_AND_SIGN: 3,
  SAVE_SHARE_AND_SIGN: 4,
};

class StaticCreateAccountForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      rePassword: '',
      newsletter: true,
      newsletterAlt: true,
      documentType: window.CurrentDocumentInfo.type,
      documentHash: window.SessionManager.hash,
      documentKey: window.SessionManager.id,
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.getRedirectUrl = this.getRedirectUrl.bind(this);

    if (this.props.onBackClickOverride) {
      this.onBackClick = this.props.onBackClickOverride;
    } else {
      this.onBackClick = this.onBackClick.bind(this);
    }
  }

  onBackClick(event) {
    event.preventDefault();
    this.props.loadPreviousStaticBuilderSection();
  }

  getRedirectUrl() {
    let redirectUrl = '';
    if (this.props.currentAction === SaveActionsEnum.SAVE_AND_SHARE
      || this.props.currentAction === SaveActionsEnum.SAVE_SHARE_AND_SIGN) {
      redirectUrl = `/_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=${this.state.documentType}&ses=${this.state.documentHash}&key=${this.state.documentKey}`;
    } else if (this.props.currentAction === SaveActionsEnum.SAVE_AND_SIGN) {
      redirectUrl = `/_api/convert-static-to-freewrite.php?action=sign&member=1&documentType=${this.state.documentType}&ses=${this.state.documentHash}&key=${this.state.documentKey}`;
    } else {
      redirectUrl = `/upgrade-pricing?ses=${this.state.documentHash}&key=${this.state.documentKey}&documentType=${this.state.documentType}`;
    }
    return redirectUrl;
  }

  handleChange(event) {
    if (event.target.dataset.statekey === 'newsletter') {
      this.setState({
        [event.target.dataset.statekey]: event.target.checked,
        newsletterAlt: event.target.checked,
      });
    } else {
      this.setState({
        [event.target.dataset.statekey]: event.target.value,
      });
    }
  }

  submitForm(event) {
    event.preventDefault();

    const errorBoxHandler = this.props.setErrorBoxState;
    const data = {
      email: this.state.email,
      password: this.state.password,
      confirm_password: this.state.rePassword,
      primary_document_type: this.state.documentType,
      session_hash: this.state.documentHash,
      session_id: this.state.documentKey,
    };
    const redirectUrl = this.getRedirectUrl();

    data['fs-newsletter'] = this.state.newsletter ? 'checked' : 'unchecked';
    data['fs-newsletter-alt'] = this.state.newsletterAlt ? 'checked' : 'unchecked';

    localStorage.removeItem(`staticSection-${window.SessionManager.id}`);
    localStorage.removeItem(`staticViewedScreens-${window.SessionManager.id}`);

    if (this.props.trackDropdownSelection) {
      switch (this.props.currentAction) {
        case SaveActionsEnum.SAVE_AND_SIGN:
          localStorage.setItem('staticRequestSignatureDropdownSelection', 'Me | Request Signature Section');
          break;
        case SaveActionsEnum.SAVE_AND_SHARE:
          localStorage.setItem('staticRequestSignatureDropdownSelection', 'Someone Else | Request Signature Section');
          break;
        case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
          localStorage.setItem('staticRequestSignatureDropdownSelection', 'Me and Someone Else | Request Signature Section');
          break;
        case SaveActionsEnum.SAVE_AND_CONTINUE:
          localStorage.setItem('staticRequestSignatureDropdownSelection', 'No one | Request Signature Section');
          break;
        default:
          localStorage.setItem('staticRequestSignatureDropdownSelection', 'No one | Request Signature Section');
      }
    }


    const self = this;
    window.FormSwiftAPI.inlineRegister(data)
    .then((result) => {
      if (result) {
        window._track('Document Created', data.primary_document_type);
        window.localStorage.setItem(`staticSection-${window.SessionManager.id}`, JSON.stringify(window.ReactCompatibility.getStaticBuilderCurrentStep()));
        window.localStorage.setItem('accountCreatedFromStaticBuilder', true);

        if (self.props.trackingId) {
          window.localStorage.setItem('accountCreatedFromStaticBuilderTrackingId', self.props.trackingId);
        }

        if (self.props.postSubmitAction === 'nextBuilderStep') {
          window.localStorage.setItem('accountCreatedFromStaticBuilder', true);
          const screenNum = window.createAccountScreen;
          window.createAccountScreen = null;
          self.props.loadStaticBuilderSection(screenNum);
        } else {
          window.location = redirectUrl;
        }
      } else {
        const errorMessage = MessageHandler.getErrorMessage(
          window.FormSwiftAPI.errorMessage,
          data.email,
        );
        errorBoxHandler(true, errorMessage);
      }
    });
  }

  render() {
    const checkboxStyles = {
      display: 'inline-block',
      paddingLeft: 10,
    };

    const checkoutLabelStyles = {
      display: 'inline-block',
    };

    return (
      <Form
        onSubmit={this.submitForm}
      >
        <div className="control-group">
          <label className="control-label" htmlFor="email">E-mail:</label>
          <div className="controls">
            <Input
              type="text"
              data-statekey="email"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
              validations={[Rules.required, Rules.email]}
            />
          </div>
        </div>
        <div className="control-group">
          <label className="control-label" htmlFor="password">Password:</label>
          <div className="controls">
            <Input
              type="password"
              data-statekey="password"
              name="password"
              value={this.state.password}
              onChange={this.handleChange}
              validations={[Rules.required]}
            />
          </div>
        </div>

        <div className="control-group">
          <label className="control-label" htmlFor="confirm_password">Confirm Password:</label>
          <div className="controls">
            <Input
              type="password"
              data-statekey="rePassword"
              name="rePassword"
              value={this.state.rePassword}
              onChange={this.handleChange}
              validations={[Rules.required, Rules.passwordConfirm]}
            />
          </div>
        </div>
        <div className="control-group">
          <label
            className="control-label"
            style={checkoutLabelStyles}
            htmlFor="newsletter"
          >
            Newsletter:
          </label>
          <div className="controls" style={checkboxStyles}>
            <label className="checkbox" htmlFor="checkbox">
              <input
                name="fs-newsletter"
                type="checkbox"
                data-statekey="newsletter"
                checked={this.state.newsletter}
                onChange={this.handleChange}
                id="newsletter"
              />
              Sign up for our free newsletter
            </label>
          </div>
        </div>
        <div className="form-actions">
          <button
            className="pull-left btn btn-large"
            onClick={this.onBackClick}
            type="button"
          >
            {this.props.backButtonCta}
          </button>
          <button
            className="pull-right btn btn-large btn-success saveButton"
            type="submit"
          >
            {this.props.saveButtonCta}
          </button>
        </div>
      </Form>
    );
  }
}

StaticCreateAccountForm.propTypes = {
  currentAction: PropTypes.number,
  onBackClickOverride: PropTypes.func,
  setErrorBoxState: PropTypes.func,
  trackDropdownSelection: PropTypes.bool,
  saveButtonCta: PropTypes.string,
  backButtonCta: PropTypes.string,
  postSubmitAction: PropTypes.string,
  trackingId: PropTypes.string,
  loadPreviousStaticBuilderSection: PropTypes.func.isRequired,
};

StaticCreateAccountForm.defaultProps = {
  currentAction: 0,
  setErrorBoxState: null,
  onBackClickOverride: null,
  trackDropdownSelection: true,
  saveButtonCta: 'Save & Create Account',
  backButtonCta: 'Back',
  postSubmitAction: 'redirect',
  trackingId: null,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loadPreviousStaticBuilderSection,
    loadStaticBuilderSection,
  }, dispatch)
);

const StaticCreateAccountFormWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(StaticCreateAccountForm);

export default StaticCreateAccountFormWithRedux;



// WEBPACK FOOTER //
// ./src-react/StaticRequestSignatureContentSection/components/StaticCreateAccountForm.jsx